'use client'

import { useMemo } from 'react'

import { Coupon } from '@definitions/types/symfonyTypes'

import { useThemeKey } from './useThemeKey'

/**
 * Hook to filter and sort coupons by theme affiliation
 */
export function useFilteredCoupons(
  coupons: Coupon[],
  themeKeyProp?: 'sunpoint' | 'wellmaxx'
): Coupon[] {
  const themeKey = useThemeKey(themeKeyProp)

  return useMemo(() => {
    const filtered = coupons.filter((coupon) => {
      return (
        (coupon.affiliations?.edges ?? []).filter(
          (e) => e?.node?.name.toLowerCase() === themeKey
        ).length > 0
      )
    })

    // Sort by sort property
    filtered.sort((couponA, couponB) => couponA.sort - couponB.sort)

    return filtered
  }, [coupons, themeKey])
}
